import { render, staticRenderFns } from "./ScheduledMessageItem.vue?vue&type=template&id=6e88d3d7&scoped=true&"
import script from "./ScheduledMessageItem.vue?vue&type=script&lang=js&"
export * from "./ScheduledMessageItem.vue?vue&type=script&lang=js&"
import style0 from "./ScheduledMessageItem.vue?vue&type=style&index=0&id=6e88d3d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e88d3d7",
  null
  
)

export default component.exports